import { getMakeAPI, Method } from '@golden/gdk-agent-next'
        const makeAPI = getMakeAPI('/')
        const GET_UPDATE_TIME = makeAPI(Method.GET, 'version.json')()
        const GET_UPDATE_TAG = makeAPI(Method.GET, 'version-tag.json')()
        const thisVersion = 1793894025
        export const getLatestVersionParams = (baseURL) => [GET_UPDATE_TIME, { config: { baseURL, withCredentials: false }, data: { time: Date.now() } }]
        export const getVersionTagParams = (baseURL) => [GET_UPDATE_TAG, { config: { baseURL, withCredentials: false }, data: { time: Date.now() } }]
        export default thisVersion